import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {ChevronUpDownIcon} from "@heroicons/react/24/outline";
import {PencilIcon} from "@heroicons/react/24/solid";
import React, {useContext} from "react";
import Dict from "../../helper/dict";
import {ServiceContext} from "../../context/service";
import persianNumberFormat from "../../helper/PersianNumberFormat";


const TABLE_HEAD = ["#", "عنوان", "توضیحات", "وضعیت", "عملیات"];

export function ServiceDocumentGrid({
  serviceDocuments,
  attentionStatuses = [],
  actionLabel = "ویرایش",
}) {

  const {setDocument, setStep} = useContext(ServiceContext);

  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
      <table className="w-full min-w-[720px] text-left">
        <thead>
        <tr>
          {TABLE_HEAD.map((head, index) => (
            <th key={head}
                className="cursor-pointer border-b border-slate-200 bg-slate-50 p-4 transition-colors hover:bg-slate-100">
              <Typography variant="small" color="blue-gray"
                          className="flex items-center justify-center gap-2 text-xs font-semibold leading-none text-slate-500">
                {head}{" "}
                {index !== TABLE_HEAD.length - 1 && (
                  <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4 text-slate-400"/>
                )}
              </Typography>
            </th>
          ))}
        </tr>
        </thead>
        <tbody className="textCenter">
        {serviceDocuments.map(
          ({id, title, description, status}, index) => {
            const isLast = index === serviceDocuments.length - 1;
            const needsAttention = attentionStatuses.includes(status);
            const classes = [
              "p-4",
              !isLast ? "border-b border-slate-100" : "",
              needsAttention ? "bg-blue-50/40" : "",
            ].filter(Boolean).join(" ");

            return (
              <tr
                key={id}
                className={`transition-colors hover:bg-slate-50 ${
                  needsAttention ? "ring-1 ring-inset ring-blue-100" : ""
                }`}
              >

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col items-center justify-center gap-1 px-4">
                    <Typography color="blue-gray" className="textRight">
                      {title}
                    </Typography>
                    {needsAttention &&
                      <span className="rounded-full bg-white px-2 py-0.5 text-xs font-semibold text-blue-700 ring-1 ring-blue-100">
                        نیازمند بارگذاری
                      </span>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div
                    className="flex justify-center px-4 hover:cursor-pointer overflow-x-clip md:hover:overflow-x-visible">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip className="textRight" variant="ghost"
                          value={Dict(status)}
                          color={status === "accepted" ? "teal" : status === "rejected" ? "red" : status === "new" ? "cyan" : status === "upload" ? "purple" : "red"}/>
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content={actionLabel}>
                    <IconButton variant="text" className="text-slate-600 hover:bg-blue-50 hover:text-blue-700" onClick={() => {
                      setDocument(serviceDocuments[index]);
                      setStep("documentation")
                      // setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}
